import { ActiveScreen, ConnectionScreenState } from "@enums/screens.enum";
import { create } from "zustand";

export interface ISystemStore {
  isAppLoading: boolean;
  isAppActive: boolean;
  isAppOffline: boolean;
  isDarkMode: boolean;
  connectionAttempt: number;
  activeScreen: ActiveScreen;
  connectionScreenState: ConnectionScreenState;
  setIsAppLoading: (value: boolean) => void;
  setIsAppActive: (value: boolean) => void;
  setIsAppOffline: (value: boolean) => void;
  setIsDarkMode: (value: boolean) => void;
  incrementConnectionAttempt: () => void;
  changeActiveScreen: (value: ActiveScreen) => void;
  setConnectionScreenState: (value: ConnectionScreenState) => void;
}

const useSystemStore = create<ISystemStore>((set) => ({
  isAppLoading: true,
  isAppActive: true,
  isAppOffline: false,
  isDarkMode: false,
  connectionAttempt: 0,
  activeScreen: ActiveScreen.LOADING,
  connectionScreenState: ConnectionScreenState.Connect,
  setIsAppLoading: (value: boolean) => set({ isAppLoading: value }),
  setIsAppActive: (value: boolean) => set({ isAppActive: value }),
  setIsAppOffline: (value: boolean) => set({ isAppOffline: value }),
  setIsDarkMode: (value: boolean) => set({ isDarkMode: value }),
  // useConnection watches the count and re-runs the connection bootstrap on each bump.
  incrementConnectionAttempt: () =>
    set((state) => ({ connectionAttempt: state.connectionAttempt + 1 })),
  changeActiveScreen: (value: ActiveScreen) => set({ activeScreen: value }),
  setConnectionScreenState: (value: ConnectionScreenState) => set({ connectionScreenState: value }),
}));

export default useSystemStore;
